import { SegmentedControl, Tooltip, type SegmentedControlValue } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export type PlaybookCadenceVisibilityToggleProps = {
    isSharedWithAccount: boolean;
    segmentValues: SegmentedControlValue[];
    segmentIndex: number;
    onSegmentChange: (index: number) => void;
    tooltipContent: string;
};

export const PlaybookCadenceVisibilityToggle = ({
    isSharedWithAccount,
    segmentValues,
    segmentIndex,
    onSegmentChange,
    tooltipContent,
}: PlaybookCadenceVisibilityToggleProps) => (
    <Tooltip
        content={tooltipContent}
        enabled={isSharedWithAccount}
    >
        <Flex
            data-automation="playbook-cadence-picker-visibility"
            inline
        >
            <SegmentedControl
                values={segmentValues}
                selectedIndex={segmentIndex}
                onChange={onSegmentChange}
            />
        </Flex>
    </Tooltip>
);
